// extracted by mini-css-extract-plugin
export default {"center":"Center_center__xB3Fx"};